import { ExperienceResolver } from './ExperienceResolver';
import { ExperienceResolverV2 } from './ExperienceResolver2';
import { connect } from './connect';

export const ExperienceResolverV1 = ExperienceResolver;

export default connect(ExperienceResolverV2);
